'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var parseNumber = exports.parseNumber = function parseNumber(value) {
  var numString = value.replace(/\D/g, '');

  if (numString.length > 9) {
    numString = numString.slice(0, -1);
  }

  return numString ? Number(numString) : null;
};

var parseCurrency = exports.parseCurrency = parseNumber;